<template>
    <div v-if="formStore.steps.length > 0 && !formStore.finalSubmission" class="grid">
        <div class="col-2">
            <Divider layout="vertical" />
        </div>
        <div class="col-10">
            <Divider layout="horizontal" align="center">
                <b>Steps Completed</b>
            </Divider>
            <Timeline :value="formStore.steps" class="completed-steps-container">
                <template #marker="slotProps">
                    <span
                        class="flex w-2rem h-2rem align-items-center justify-content-center border-circle text-white z-1 shadow-1"
                        :class="{ 'border-dotted': slotProps.item?.code === formStore.currentStep?.code }"
                        :style="{ backgroundColor: '#9C27B0' }"
                    >
                        <i class="pi pi-check"></i>
                    </span>
                </template>
                <template #content="slotProps">
                    <div id="stepLabel" @click="formStore.switchStep(slotProps.item.code)">{{ slotProps.item.label === 'user_block' ? 'User Profile' : slotProps.item.label }}</div>
                </template>
            </Timeline>
        </div>
    </div>
</template>

<script setup>
import { useAssessmentFormStore } from '../store';
const formStore = useAssessmentFormStore();
</script>

<style lang="scss">
.completed-steps-container {
    max-height: 45vh;
    overflow-y: auto;
}

// to hide the left end on the timeline steps
.p-timeline-event-opposite {
    display: none;
}
#stepLabel:hover {
    cursor: pointer;
}
</style>
